<template>
  <gj-modal
    size="1200_auto"
    notFooterPadding
    :visible.sync="modalVisible"
    @cancel="cancel"
    @confirm="confirm">
    <template #header>商品选择</template>
    <template #content>
      <span class="tag" :class="{red: selectedRows.length > maxNumber}">已选择{{ selectedRows.length }}个商品（最多选择{{ maxNumber }}个）</span>
      <gj-input
        v-model="searchText"
        placeholder="输入ASIN搜索"
        :clearable="true"
        width="170px">
        <template #append>
          <i class="el-input__icon el-icon-search"></i>
        </template>
      </gj-input>
      <gj-table
        ref="gjTable"
        :index="false"
        :adapt-height="false"
        :height="394"
        :data="tableDataNew"
        @selection-change="selectionChange"
        :pageSizes="[20, 50]"
        :pagination="tableDataProps?null:pagination"
        selection
        :loading="loading"
        :columns="columns"
        @page-change="getData"
      >
        <template v-slot:title="{ row }">
          <div style="margin: 4px 0;">
            <gj-tooltip
              :text-line="1"
              :content="row.title">
              {{row.title | defaultShow}}
            </gj-tooltip>

            <el-row>
              <el-col :span="4">
                <div class="flex align-center" :class="{'colorRed':AdWarnEnum[row.availability].name==='缺货'}" style="width: 90px;" v-if="row.availability">
                  {{AdWarnEnum[row.availability].name}}
                  <gj-help style="margin-left: 4px;" v-if="AdWarnEnum[row.availability].text">{{AdWarnEnum[row.availability].text}}</gj-help>
                </div>
              </el-col>
              <el-col :span="4">
                  <div>
                    <span class="colorRed">{{row.priceToPay | defaultShow(row.currencySymbol)}}</span>
                    <span class="color999 strikethrough" style="margin-left: 12px;position: relative" v-if="row.priceToPay!==row.basisPrice">{{row.basisPrice | defaultShow(row.currencySymbol,'','')}}</span>
                  </div>
              </el-col>
              <el-col :span="6">
                <span style="font-weight: 600;">ASIN：</span>{{row.asin | defaultShow}}
              </el-col>
              <el-col :span="10"  style="display: flex;">
                <span style="font-weight: 600;">MSKU：</span>
                <span class="msku-class" :title="row.msku">{{row.msku | defaultShow}}</span>
              </el-col>
            </el-row>
          </div>
        </template>

        <template v-slot:op="{ row }">
          <gj-tooltip v-if="row.eligibilityStatus==='INELIGIBLE'">
            <template #content>
              <div class="gj-tooltip-content">
                <div style="font-size: 13px;font-weight: 600;">不符合条件的商品</div>
                <div class="size12">该商品不能推广，因为：</div>
                <div class="flex" style="align-items: baseline" v-for="(s,index) in row.ineligibilityReasons" :key="index">
                  <span class="content-reason"></span>
                  <span>{{s}}</span>
                </div>
              </div>
            </template>
            <gj-tag :color="tagColors.redDark" class="flex align-center justify-center img-tag">
              <i class="iconfont icontishixiangqing"></i>
              不符合
            </gj-tag>
          </gj-tooltip>

          <gj-tooltip v-if="row.eligibilityStatus==='ELIGIBLE_WITH_WARNING'">
            <template #content>
              <div class="gj-tooltip-content">
                <div style="font-size: 13px;font-weight: 600;">广告可能已暂停</div>
                <div class="size12">可能无法获取展示，因为：</div>
                <div class="flex" style="align-items: baseline;" v-for="(s,index) in row.ineligibilityReasons" :key="index">
                  <span class="content-reason"></span>
                  <span>{{s}}</span>
                </div>
              </div>
            </template>
            <gj-tag :color="tagColors.orangeDark" class="flex align-center justify-center img-tag">
              <i class="iconfont icontishixiangqing"></i>
              警告
            </gj-tag>
          </gj-tooltip>
        </template>

      </gj-table>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, queryMixin, selectionMixin } from "@/minxins";
import {productsUnderTheMarket, getAsinAccordingToUrl, eligibility, getItemsPage} from "@/api/ad";
import {tagColors} from "@/components/tag/tag-colors";
import {AdTypeEnum, AdWarnEnum} from "@/views/modules/ad/common/enum";
import {isMeaningful} from "@/utils/common";

export default {
  mixins: [modalMixIn, queryMixin, selectionMixin],
  props: {
    tableDataProps: {
      default: null
    },
    pageUrl: {
      default: null
    },
    marketId: {
      default: null
    },
    maxNumber: {
      default: 1
    },
    // 选中的项
    selectValue: {
      default: ()=> []
    }
  },
  data() {
    return {
      AdWarnEnum,
      tagColors,
      searchText: "",
      loading: false,
      tableData: [],
      columns: [
          {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '60px'},
          {id: 'listingTitle', header: '商品信息',field: 'slot:title', minWidth: '180px'},
          {id: 'op', header: '',field: 'slot:op', width: '100'},
        ],
      setTime:null
    }
  },
  computed: {
    tableDataNew() {
      let tableData = this.tableData || []
      if (this.selectValue.length != 0) {
        // 排除
        tableData = tableData.filter(e => !this.selectValue.includes(e.asin))
      }
      return (tableData).filter(e => String(e.asin).toLowerCase().includes(this.searchText.toLowerCase()))
    }
  },
  watch:{
    searchText:{
      handler(){
        if (!this.tableDataProps) {
          clearTimeout(this.setTime)
          this.setTime = setTimeout(()=>{
            this.queryPagination.current = 1;
            this.getData()
          },500)
        }
      }
    }
  },
  methods: {
    confirm() {
      if (this.selectedRows.length > this.maxNumber) return this.$gjMessage.error(`最多选择${this.maxNumber}个商品`)
      this.$gjDestroy();
      this.$emit("update", this.selectedRows)
    },
    // 获取选中的row
    selectionChange(rows) {
      this.selectedRows = rows;
    },
    // 获取商品数据
    async productsUnderTheMarket() {
      this.loading = true
      const parmas = {
        model:{
          adType: AdTypeEnum.SB,// 广告类型 ------ **枚举值**: `0`: 商品广告 `1`: 品牌广告 `2`: 展示广告
          marketId: this.marketId,
          sortType: '1',
          keyword:this.searchText
        },
        ...this.querySort,
        ...this.queryPagination
      }
      try {
        let data = await getItemsPage(parmas)
        this.tableData = data.records.map(e => ({
          ...e,
          listingTitle: e.title
        }));
        this.pagination = this.getPagination(data);
        await this.getEligibility(this.tableData)
      } finally {
        this.loading = false
      }
    },
    // async productsUnderTheMarket() {
    //   this.loading = true
    //   const parmas = {
    //     marketId: this.marketId
    //   }
    //   try {
    //     let { data = [] } = await productsUnderTheMarket(parmas)
    //     this.tableData = data;
    //     await this.getEligibility(this.tableData)
    //   } finally {
    //     this.loading = false
    //   }
    // },
    // 根据url获取商品
    async getAsinAccordingToUrl() {
      this.loading = true
      const params = {
        marketId: this.marketId,
        pageUrl: this.pageUrl
      }
      try {
        let { data = [] } = await getAsinAccordingToUrl(params)
        // this.tableData = data;
        let asinList = data.map(r=>r.asin)

        const parmas = {
          model:{
            adType: AdTypeEnum.SB,// 广告类型 ------ **枚举值**: `0`: 商品广告 `1`: 品牌广告 `2`: 展示广告
            marketId: this.marketId,
            sortType: '1',
            keyword:this.searchText,
            asinList
          },
          ...this.querySort,
          ...this.queryPagination
        }

        let data2 = await getItemsPage(parmas)
        this.tableData = data2.records.map(e => ({
          ...e,
          listingTitle: e.title
        }));
        this.pagination = this.getPagination(data2);

        await this.getEligibility(this.tableData)
      } finally {
        this.loading = false
      }
    },
    // async getAsinAccordingToUrl() {
    //   this.loading = true
    //   const params = {
    //     marketId: this.marketId,
    //     pageUrl: this.pageUrl
    //   }
    //   try {
    //     let { data = [] } = await getAsinAccordingToUrl(params)
    //     this.tableData = data;
    //     await this.getEligibility(this.tableData)
    //   } finally {
    //     this.loading = false
    //   }
    // },
    //通过列表获取状态等
    async getEligibility(tableData) {
      //tableData 表格数据    data 用于请求的数据
      if (tableData.length === 0) return
      let params = {
        adType: AdTypeEnum.SB,//广告类型 ------ **枚举值**: `0`: 商品广告 `1`: 品牌广告 `2`: 展示广告
        marketId: this.marketId
      }
      params.asinList = tableData.map(r => {
        return {
          asin: r.asin,
          msku: r.msku
        }
      })
      await eligibility(params).then(res => {
        if (res) {
          tableData.forEach(r => {
            Object.assign(r, res.find(d => d.asin === r.asin && d.msku === r.msku))
          })
        }
      })
    },
    getData(){
      if(this.pageUrl) {
        this.getAsinAccordingToUrl()
      }else {
        this.productsUnderTheMarket()
      }
    }
  },
  created() {
    if (this.tableDataProps) {
      this.tableData = this.tableDataProps
    }else {
      this.getData()
    }
  }
};
</script>

<style scoped lang="scss">
.tag {
  font-size: 12px;
  color: #333;
  padding: 8px 24px 14px 0;
}
.red {
  color: #f00;
}
/deep/.vxe-table--main-wrapper {
  border: 1px solid #eee;
  margin: 12px 0 0;
}
/deep/ .el-input__inner{
  padding-right: 44px;
}
.mail-reply-input_close{
  color: #c0c4cc;
  cursor: pointer;
  display: none;
  &:hover{
    color: #999999;
  }
}
/deep/ .el-input{
  &:hover, &:focus{
    .mail-reply-input_close{
      display: inline-block;
    }
  }
}
/deep/.el-input-group__append {
  .el-input__icon.el-icon-search {
    line-height: 1;
  }
}
.strikethrough::after{
  content: '';
  width: 100%;
  height: 1px;
  position: absolute;
  left: 0;
  top:50%;
  border-bottom: 1px solid #979797;
}
.img-tag{
  border-radius: 2px;
  padding: 0;
  height: 18px;
  width: 54px;
  .icontishixiangqing{
    font-size: 12px;
    margin-right: 2px;
  }
}
.gj-tooltip-content{
  div+div{
    margin-top: 8px;
    line-height: 19px;
  }
  .content-reason{
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background-color: white;
    margin-right: 8px;
    flex: none;
  }
}
</style>